import { Link as NavLink, LinkProps } from 'react-router-dom'
import useDirectory from 'hooks/useDirectory'

export default function Link(props: LinkProps) {
  const { getDirectoryBasename } = useDirectory()

  const { to, ...rest } = { ...props }

  // v1.1 - 25/03/2026 - Fix [object Object] bug when `to` is an object
  const resolvedTo =
    typeof to === 'object' && to !== null && 'pathname' in to
      ? {
          ...to,
          pathname: `${getDirectoryBasename()}${to.pathname}`
        }
      : `${getDirectoryBasename()}${to}`
  // end v1.1

  return <NavLink to={resolvedTo} {...rest} />
}
